import { Link } from 'react-router-dom';
import { Home, Search, ArrowLeft } from 'lucide-react';

export default function NotFound() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center max-w-md">
        <div className="text-8xl font-bold text-gray-200 mb-4">404</div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Page not found</h1>
        <p className="text-gray-600 mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex items-center justify-center gap-3">
          <Link to="/" className="btn btn-primary flex items-center gap-2">
            <Home className="w-4 h-4" />
            Go to Dashboard
          </Link>
          <Link to="/research" className="btn btn-secondary flex items-center gap-2">
            <Search className="w-4 h-4" />
            Research Niches
          </Link>
        </div>
        <button
          onClick={() => window.history.back()}
          className="mt-4 text-gray-500 hover:text-gray-700 flex items-center gap-1 mx-auto"
        >
          <ArrowLeft className="w-4 h-4" />
          Go back
        </button>
      </div>
    </div>
  );
}
